import React from 'react';
import './feed.style.scss';


function Feed(props) {


    return (
        <div className='tmex-feed'>
            <img src={props.image} alt='feed'/>

            <p className='topic'>{props.topic}</p>
            <h4 className='title'>{props.title}</h4>
            <p className='text'>{props.text.length > 115
                ? props.text.substr(0, 115) + ' ...'
                : props.text}</p>
            <span/>
            <div className='detail'>
                <div className='author'>
                    <img className='profile-pic' src={props.profilePic} alt='author'/>
                    <div className='name'>
                        <h5 className='author'>{props.author}</h5>
                        <p className='time'>{props.time}</p>
                    </div>
                </div>
                <span/>
                <div className='like'>
                    <a href={props.like} target='_blank'>ادامه مطلب</a>
                </div>
            </div>

        </div>

    )
}

export default Feed;
